import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: 15,
    government: 12,
    office: 10,
  },
  education: {
    childcare: 2,
    high_school: 5,
    library: 5,
    primary: 5,
    university: 12,
  },
  essentials: {
    electricity: 10,
    gas: 10,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 5,
    coffee: 5,
    fast_food: 7,
    restaurant: 5,
  },
  health: {
    clinic: 7,
    dentist: 5,
    hospital: 5,
    pharmacy: 7,
  },
  nature: {
    beach: -5,
    forest: -5,
    lake: -5,
    mountain: -10,
    park: 0,
    river: 0,
  },
  religion: {
    church: -5,
    mosque: -5,
  },
  shops: {
    grocery: 10,
    mall: 5,
  },
  soil: {
    clay: 0,
    loam: 0,
    peat: -5,
    salt: -10,
    sand: -5,
    silt: 0,
  },
  sport: {
    gym: 5,
    pool: 5,
  },
  telecom: {
    cable_tv: 10,
    fiber_optic: 15,
    network_4g: 12,
    network_5g: 10,
    phone: 15,
  },
  transport: {
    airport: 12,
    bus: 8,
    ferry: 0,
    gas_station: 8,
    metro: 10,
    parking: 12,
    taxi: 10,
    train: 12,
    tram: 10,
  },
};

export default PLACES_PROFILE;
